import { useCallback, useEffect, useRef } from "react";
import { wakeAfterDarkMs, wakeReload, wakeReloadDelayMs } from "../constants";
import { reloadPage } from "../utils/pageReload";

// Na een nacht zonder tv de pagina vers laden (utils/pageReload.js): daarna loopt het beeld op de
// Pi vaak stroef en is het geluid weg, tot er een nieuw tabblad komt.
// "Verkopen gemist" blijft werken: useSaleEvents heeft het moment dat het beeld wegviel al in
// localStorage gezet (touchLastSeen), dus de verse pagina haalt de nacht gewoon in.

// Zolang er een herlaadbeurt aankomt slaat useSaleEvents zijn rondes over, net als bij een
// donker scherm; anders speelt "Verkopen gemist" hier en wordt het afgebroken door het herladen.
let pending = false;

export const wakeReloadPending = () => pending;

// Handlers voor useScreenAwake. Na een korte donkere tijd gewoon refresh; na een lange eerst
// wakeReloadDelayMs wachten en dan herladen (antwoordt de server niet, dan alsnog refresh).
export function useWakeReload(refresh) {
  const timer = useRef(null);
  const refreshRef = useRef(refresh);
  refreshRef.current = refresh;

  const cancel = useCallback(() => {
    clearTimeout(timer.current);
    timer.current = null;
    pending = false;
  }, []);

  useEffect(() => cancel, [cancel]);

  const onWake = useCallback(
    ({ sleptMs = 0 } = {}) => {
      cancel();
      if (!wakeReload || sleptMs < wakeAfterDarkMs) {
        refreshRef.current();
        return;
      }

      pending = true;
      timer.current = setTimeout(async () => {
        timer.current = null;
        const minutes = Math.round(sleptMs / 60000);
        if (await reloadPage("wake", `tv terug na ${minutes} min`)) return;
        pending = false;
        refreshRef.current();
      }, wakeReloadDelayMs);
    },
    [cancel],
  );

  return { onWake, cancel };
}
